export const statesMap = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  'District of Columbia': 'DC',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indaina: 'IN',
  Iowa: 'IA',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachussetts: 'MA',
  Michigan: 'MI',
  Minnessota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY'
}

export const abbrMap = {
  al: 'Alabama',
  ak: 'Alaska',
  az: 'Arizona',
  ar: 'Arkansas',
  ca: 'California',
  co: 'Colorado',
  ct: 'Connecticut',
  dc: 'District of Columbia',
  de: 'Delaware',
  fl: 'Florida',
  ga: 'Georgia',
  hi: 'Hawaii',
  id: 'Idaho',
  il: 'Illinois',
  in: 'Indaina',
  ia: 'Iowa',
  ky: 'Kentucky',
  la: 'Louisiana',
  me: 'Maine',
  md: 'Maryland',
  ma: 'Massachussetts',
  mi: 'Michigan',
  mn: 'Minnessota',
  ms: 'Mississippi',
  mo: 'Missouri',
  mt: 'Montana',
  ne: 'Nebraska',
  nv: 'Nevada',
  nh: 'New Hampshire',
  nm: 'New Mexico',
  ny: 'New York',
  nc: 'North Carolina',
  nd: 'North Dakota',
  oh: 'Ohio',
  ok: 'Oklahoma',
  or: 'Oregon',
  pa: 'Pennsylvania',
  ri: 'Rhode Island',
  sc: 'South Carolina',
  sd: 'South Dakota',
  tn: 'Tennessee',
  tx: 'Texas',
  ut: 'Utah',
  vt: 'Vermont',
  va: 'Virginia',
  wa: 'Washington',
  wv: 'West Virginia',
  wi: 'Wisconsin',
  wy: 'Wyoming'
}

export const EMAIL_CAPTURE_FOOTER_ID = 'email-capture-footer'

export const SPECIALTY_SAMEAS_LINKS = {
  ADHD: 'https://en.wikipedia.org/wiki/Attention_deficit_hyperactivity_disorder',
  'Adolescent mental health': 'https://en.wikipedia.org/wiki/Adolescence',
  'Anxiety disorders': 'https://en.wikipedia.org/wiki/Anxiety',
  Autism: 'https://en.wikipedia.org/wiki/Autism_spectrum',
  'Career and work-life balance': 'https://en.wikipedia.org/wiki/Work%E2%80%93life_balance',
  'Child & Teen Mental Health': 'https://en.wikipedia.org/wiki/Child_development',
  'Couples and marriage': 'https://en.wikipedia.org/wiki/Couples_therapy',
  'Couples therapy': 'https://en.wikipedia.org/wiki/Couples_therapy',
  'Culture and ethnic identity': 'https://en.wikipedia.org/wiki/Cultural_identity',
  'Depersonalization disorder': 'https://en.wikipedia.org/wiki/Depersonalization-derealization_disorder',
  'Developmental challenges': 'https://en.wikipedia.org/wiki/Developmental_disability',
  'Disassociative identity disorder': 'https://en.wikipedia.org/wiki/Dissociative_disorder',
  'Eating disorders': 'https://en.wikipedia.org/wiki/Eating_disorder',
  'Family dynamics': 'https://en.wikipedia.org/wiki/Family_therapy',
  'Family therapy': 'https://en.wikipedia.org/wiki/Family_therapy',
  'Grief and loss': 'https://en.wikipedia.org/wiki/Grief',
  'Identity & Personal Growth': 'https://en.wikipedia.org/wiki/Personal_development',
  'LGBTQIA+': 'https://en.wikipedia.org/wiki/LGBTQ',
  'Mental Health Conditions': 'https://en.wikipedia.org/wiki/Mental_disorder',
  'Mood disorders': 'https://en.wikipedia.org/wiki/Mood_disorder',
  'OCD and related disorders': 'https://en.wikipedia.org/wiki/Obsessive%E2%80%93compulsive_disorder',
  'Other neurodevelopmental disorders': 'https://en.wikipedia.org/wiki/Neurodevelopmental_disorder',
  'Other psychological disorders': 'https://en.wikipedia.org/wiki/Mental_disorder',
  'Other psychotic disorders': 'https://en.wikipedia.org/wiki/Psychosis',
  'Parenting support': 'https://en.wikipedia.org/wiki/Parenting',
  'Personality disorders': 'https://en.wikipedia.org/wiki/Personality_disorder',
  PTSD: 'https://en.wikipedia.org/wiki/Post-traumatic_stress_disorder',
  'Relationships & Communication': 'https://en.wikipedia.org/wiki/Interpersonal_relationship',
  Schizophrenia: 'https://en.wikipedia.org/wiki/Schizophrenia',
  'Self-care': 'https://en.wikipedia.org/wiki/Self-care',
  'Self-esteem and confidence': 'https://en.wikipedia.org/wiki/Self-esteem',
  'Stress management': 'https://en.wikipedia.org/wiki/Stress_(biology)',
  'Substance use disorder': 'https://en.wikipedia.org/wiki/Substance_use_disorder',
  Trauma: 'https://en.wikipedia.org/wiki/Psychological_trauma',
  'Values and beliefs': 'https://en.wikipedia.org/wiki/Value_(ethics)'
}
